import { Card, Container } from "react-bootstrap";

const AddForm = ({...props}) => {
    return ( 
        <Container className="py-4 d-flex justify-content-center align-items-center" style={{minHeight: '75vh'}}>
            <Card className="border-0 addForm">
                <h3 className="mb-5">{props.title}</h3>
                {props.children}
            </Card>
        </Container>
     );
}
 
export default AddForm;